import {
	Injectable,
	Injector
}                                   from '@angular/core';
import { AppInjector }              from '@core/services/app-injector.service';
import {
	createEntityAdapter,
	EntityAdapter
}                                   from '@ngrx/entity';
import { LIST_OPERATIONS_METADATA } from '@shared/list-operations/config/list-operations.config';
import { ListOperations }           from '@shared/list-operations/model/list-operations.model';
import {
	IListOperationsActions,
	listOperationsActions
}                                   from '@shared/list-operations/store/list-operations.actions';
import { listOperationsReducer }    from '@shared/list-operations/store/list-operations.reducer';
import { listOperationsSelectors }  from '@shared/list-operations/store/list-operations.selectors';
import { ListOperationsState }      from '@shared/list-operations/store/list-operations.state';
import { LoggerService }            from '@shared/services/logger.service';
import { take }                     from 'rxjs/operators';

@Injectable()
class ListOperationsStore {
	private readonly listOperationsMetadata = LIST_OPERATIONS_METADATA;

	private readonly _storeId = this.listOperationsMetadata.storeId;

	private _initialState: ListOperationsState;

	private _adapter: EntityAdapter<ListOperations>;

	private _actions: IListOperationsActions;

	private _selectors;

	private _reducers;

	private _logger: LoggerService;

	get storeId() { return this._storeId; }

	get initialState() { return this._initialState; }

	get reducers() { return this._reducers; }

	get actions() { return this._actions; }

	get selectors() { return this._selectors; }

	constructor() {
		this.init();

		AppInjector.getInjector$()
		.pipe( take( 1 ) )
		.subscribe( ( injector: Injector ) => {
			this._logger = injector?.get( LoggerService );
			this.init();
		} );
	}

	private init(): void {
		this._adapter = createEntityAdapter<ListOperations>( {
			selectId: this.selectListOperationsId,
			sortComparer: false
		} );

		this._initialState = {
			adapter: this._adapter.getInitialState(),
			activeListOperationsId: null
		};

		this._actions = listOperationsActions( this._storeId );
		this._reducers = listOperationsReducer( this._storeId, this._initialState, this._adapter, this._logger );
		this._selectors = listOperationsSelectors( this._adapter, this._storeId, this._logger );
	}

	private selectListOperationsId( listOperations: ListOperations ): string {
		return listOperations.id as unknown as string;
	}
}

export const listOperationsStore = new ListOperationsStore();

